import React from "react";
import VerticalPoints from "../../Common/VerticalPoints/VerticalPoints";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import { useDispatch } from "react-redux";
import { openCenteredModal } from "../../../REDUX/actions/centeredModal";
import ConfirmModal from "../../Common/Modal/ConfirmModal";
import { useTranslation } from "react-i18next";
import ProspectUserForm from "./ProspectUserForm";
import { deleteProspectUser } from "../../../REDUX/actions/prospects";

const ProspectUserCard = ({
  id,
  firstName,
  lastName,
  phoneNumber,
  email,
  occupation,
  prospect,
}) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  return (
    <div>
      <div
        className={`row px-4 py-4 d-flex justify-content-between align-items-center w-100 orderCardContainer `}
        onClick={() =>
          dispatch(
            openRightModal(
              <ProspectUserForm id={id} prospectId={prospect?.data?.id} />
            )
          )
        }
      >
        <span className={`f14 normal col-3 text-black`}>{lastName ?? "-"}</span>
        <span className={`f14 normal col-3 text-black`}>
          {firstName ?? "-"}
        </span>
        <span className={`f14 normal col-2 text-lightBlack`}>
          {phoneNumber ?? "-"}
        </span>
        <span className={`f14 normal col-3 text-lightBlack`}>
          {email ?? "-"}
        </span>
        {/* <span className={`f14 normal col-2 text-lightBlack`}>{occupation}</span> */}
        <span className="col-1">
          <VerticalPoints
            showLeft
            options={[
              {
                text: t("Edit"),
                callback: () =>
                  dispatch(
                    openRightModal(
                      <ProspectUserForm
                        id={id}
                        prospectId={prospect?.data?.id}
                      />
                    )
                  ),
              },
              {
                text: t("Delete"),
                red: true,

                callback: () =>
                  dispatch(
                    openCenteredModal(
                      <ConfirmModal
                        label={t("The profile")}
                        id={id}
                        onConfirm={() => {
                          dispatch(deleteProspectUser(id, t));
                        }}
                      />
                    )
                  ),
              },
            ]}
            className="ms-auto"
          />
        </span>
      </div>
    </div>
  );
};

export default ProspectUserCard;
